import { render } from "./NcrmMailjetManageListsDialog.vue?vue&type=template&id=0a789c10"
import script from "./NcrmMailjetManageListsDialog.vue?vue&type=script&lang=js"
export * from "./NcrmMailjetManageListsDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__